export const actionTypes = {
    CHANGE_PASSWORD_SUCCESS: 'CHANGE_PASSWORD_SUCCESS',
    CHANGE_PASSWORD_FAILURE: 'CHANGE_PASSWORD_FAILURE',
    CHANGE_PASSWORD_LOADER: 'CHANGE_PASSWORD_LOADER',
    RESET_FORM_RESET_BOOLEAN:'RESET_FORM_RESET_BOOLEAN'
  };
  